export interface BudgetOption {
  label: string;
  min: number;
  max: number;
}

export const budgetOptions: BudgetOption[] = [
  { label: "Under $10k", min: 0, max: 10000 },
  { label: "$10k - 25k", min: 10000, max: 25000 },
  { label: "$25k-50k", min: 25000, max: 50000 },
  { label: "$50k-100k", min: 50000, max: 100000 },
  { label: "$100k+", min: 100000, max: 250000 },
  { label: "Not sure yet", min: 0, max: 0 },
];
